<div class="seatcard">
  <span class="pointer" (click)="onSelectedHotel()">
    <span  *ngIf="facadeCheckout.hotelPrice$ | async as hotelPrice; else showPrice">
      {{ (hotel.rooms[0].rates[0].actualPrice - hotelPrice) >= 0 ? '+' : '-' }}
      {{ (hotel.rooms[0].rates[0].actualPrice - hotelPrice) | abs | currencyConverter123 | async }}
    </span>
    <ng-template #showPrice>
      +{{ hotel.rooms[0].rates[0].price | currencyConverter123 | async }}
    </ng-template>
  </span>
  <div class="image-container">
    <div *ngIf="hotel.images && hotel.images.length > 0">
        <img [src]="hotel.images[0].url || '/assets/images/room-placeholder.jpg'" 
        onerror="this.onerror=null; this.src='/assets/images/room-placeholder.jpg';"
        alt="Hotel Placeholder" 
        width="" height=""/>
    </div>
  </div>
  <div class="content">
    <div class="hotel-opt" *ngIf="showSelection">
      <label class="cst-chkbx" for="{{ hotel.id }}">
        <input
          type="checkbox"
          id="{{ hotel.id }}"
          name="{{ hotel.id }}main"
          checked="true"
          [disabled]="true"
        />
        <span class="checkmark"></span>
      </label>
    </div>
    <h2>
      {{ hotel.name }}
    </h2>
    <p href="javascript:void(0)" (click)="showMapPopupHandler()" class="map-address">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M11.0009 1.83301C9.63593 1.8529 8.32712 2.37971 7.32897 3.31101C6.33083 4.2423 5.7147 5.51152 5.60038 6.87186C5.48607 8.23221 5.88174 9.58645 6.71046 10.6713C7.53919 11.7561 8.74173 12.4939 10.0843 12.7413V19.2497C10.0843 19.4928 10.1808 19.7259 10.3527 19.8979C10.5247 20.0698 10.7578 20.1663 11.0009 20.1663C11.244 20.1663 11.4772 20.0698 11.6491 19.8979C11.821 19.7259 11.9176 19.4928 11.9176 19.2497V12.7413C13.2601 12.4939 14.4627 11.7561 15.2914 10.6713C16.1201 9.58645 16.5158 8.23221 16.4015 6.87186C16.2872 5.51152 15.671 4.2423 14.6729 3.31101C13.6747 2.37971 12.3659 1.8529 11.0009 1.83301ZM11.0009 9.16634C10.6383 9.16634 10.2839 9.05882 9.98238 8.85737C9.68089 8.65592 9.44591 8.36959 9.30715 8.03459C9.16839 7.6996 9.13208 7.33097 9.20282 6.97534C9.27356 6.61971 9.44817 6.29304 9.70457 6.03664C9.96096 5.78025 10.2876 5.60564 10.6433 5.5349C10.9989 5.46416 11.3675 5.50047 11.7025 5.63923C12.0375 5.77799 12.3238 6.01297 12.5253 6.31446C12.7267 6.61595 12.8343 6.97041 12.8343 7.33301C12.8343 7.81924 12.6411 8.28555 12.2973 8.62937C11.9535 8.97319 11.4872 9.16634 11.0009 9.16634Z"
          fill="black"
        />
      </svg>
      {{
        hotel.address.street +
          ", " +
          hotel.address.city +
          ", " +
          hotel.address.postalCode +
          ", " +
          hotel.address.country
      }}
      <br/>
      <span *ngIf="this.similarRoomCount > 1">
        {{this.similarRoomCount}} similar rooms
      </span>
      <p *ngIf="hotel.distance" class="distance">
        {{ hotel.distance }} km from 
        <ng-container *ngIf="selectedSort?.city === 'ctep'; else defaultText">
          event place
        </ng-container>
        <ng-template #defaultText>center</ng-template>
      </p>
    
    <div class="btn-location">
      <!-- <p class="location-review">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.59444 1.80556C8.59444 0.722222 7.52411 0 6.68778 0C6.10567 0 6.06017 0.442 5.97061 1.31444C5.93089 1.69722 5.88322 2.16233 5.77778 2.70833C5.499 4.15422 4.53556 6.00167 3.614 6.55417V10.8333C3.61111 12.4583 4.15278 13 6.5 13H9.22495C10.7965 13 11.1771 11.9651 11.3187 11.5816L11.3281 11.5556C11.4104 11.3346 11.5866 11.1605 11.7888 10.9633C12.0127 10.7423 12.2684 10.4917 12.4583 10.1111C12.6829 9.66117 12.6533 9.26105 12.6266 8.905C12.61 8.68906 12.5948 8.48972 12.6389 8.30556C12.6851 8.11056 12.7443 7.9625 12.8014 7.82094C12.9047 7.56383 13 7.3255 13 6.86111C13 5.77778 12.4598 5.057 11.3281 5.057H8.30556C8.30556 5.057 8.59444 2.88889 8.59444 1.80556ZM1.08333 5.77778C0.796015 5.77778 0.520465 5.89191 0.317301 6.09508C0.114136 6.29824 0 6.57379 0 6.86111V11.9167C6.05477e-09 12.204 0.114136 12.4795 0.317301 12.6827C0.520465 12.8859 0.796015 13 1.08333 13C1.37065 13 1.6462 12.8859 1.84937 12.6827C2.05253 12.4795 2.16667 12.204 2.16667 11.9167V6.86111C2.16667 6.57379 2.05253 6.29824 1.84937 6.09508C1.6462 5.89191 1.37065 5.77778 1.08333 5.77778Z" fill="black"/>
        </svg> Location 4.5/5
      </p> -->
      <tic-button
        class=""
        [buttonText]="'hotelsPage.common.btnViewHotel'"
        (btnClick)="onSelectedHotel()"
      ></tic-button>
    </div>
  </div>
</div>
<section *ngIf="showMapPopup"
  [ngClass]="{'showRoom': showMapPopup, luggage: true, 'flight-popup': true }"
  appOutside
  (click)="ClickedOutMapPopup($event)"
>
  <div class="luggage-container">
    <div class="close-popup">
      <svg
        (click)="closeMapPopup()"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g _ngcontent-sml-c41="" opacity="0.5">
          <path
            _ngcontent-sml-c41=""
            d="M18 6L6 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            _ngcontent-sml-c41=""
            d="M6 6L18 18"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </div>
    <div class="flight">
      <iframe [src]="getEmbeddedMapUrl()" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="true" loading="lazy"></iframe>
    </div>
  </div>
</section>